export default __webpack_public_path__ + "static/media/certifiedDigitalT.41048037.png";